import React, { Component } from 'react';
import MicTest from "../../webrtc-validator/mictest";
import TestCase from "./test_case";

export default class PermissionsTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initializeTest: true,
      goNextState: false,
    };
    this.onTestInitialized = this.onTestInitialized.bind(this);
  }

  onTestInitialized() {
    this.setState({ initializeTest: false });
    const self = this;
    const p = navigator.mediaDevices.getUserMedia({audio: true, video: true});

    p.then(mediaStream => {
      self.setState({ goNextState: true });
    }).catch(err => {
      console.log(err);
      this.setState({ initializeTest: true });
      alert("Debes aceptar los permisos de audio y video. Intenta nuevamente presionando el botón \"INICIAR TEST\"");
    });
  }

  render() {
    return (
        <div>
          <h3 className={"text-center"}>Configuración inicial</h3>
          <h4 className='text-center'>Paso {this.props.currentStep} de {this.props.totalSteps}</h4>
          <p>
            Durante la video-conferencia, Usted entablará una comunicación de audio y video (similar al funcionamiento de aplicaciones
            como <a href="https://hangouts.google.com" target={"_blank"} rel={"Google Hangouts"}>Google Hangouts</a>). Para que este
            proceso funcione correctamente, deberá permitir que nuestra aplicación use el audio y video de su computadora.
          </p>
          <p>
            <strong>Usted siempre estará informado de cuando nuestro sistema esté utilizando su audio y video. Nunca lo utilizaremos sin su permiso.</strong>
          </p>
          <p>
            Para comenzar, presione en el botón "Iniciar Test". Luego, su navegador, le permitirá entregar los permisos necesarios
            de audio y video a la aplicación. <strong>Deberá presionar en el botón de "Permitir"</strong> en el recuadro que le indique su navegador.
          </p>

          <button className='btn btn-primary btn-block' disabled={!this.state.initializeTest} onClick={this.onTestInitialized}>
            INICIAR TEST
          </button>

          {
            this.state.goNextState &&
              <button className='btn btn-primary btn-block' disabled={!this.state.goNextState} onClick={this.props.nextStep}>
                Siguiente
              </button>
          }
        </div>
    );
  }
}
